import { Link } from 'gatsby'
import styled from '@emotion/styled'

// CTA
export const Cta = styled.a`
  color: ${props => props.theme.colors.blackBlue};
  font-size: ${props => props.theme.colors.paragraph};
  line-height: 2.2rem;
  text-decoration: none;
  font-weight: 700;
  display: inline-flex;
  align-item: center;
  transition: color 0.2s ease-out;
  &:hover {
    color: ${props => props.theme.colors.greyDarkblue};
    text-decoration: underline;
  }
`

export const CtaPhone = styled.div`
  font-size: 2.4rem;
  position: absolute!important;
  top: 10rem;
  right: 2.5rem;
  z-index: 1;
  padding: 0!important;
  box-shadow: none!important;
  background: none!important;
  color: #183056;
  @media (max-width: ${props => props.theme.breakpoints.l}) {
    top: 7rem;
    font-size: 2.2rem;
  }
  a {
    padding: 1rem 2rem;
    border-radius: 3rem;
    background: white;
    box-shadow: 0 24px 32px 0 rgba(0,0,0,0.03), 0 8px 32px 0 rgba(0,0,0,0.06);
    margin-left: 1.5rem;
    text-decoration: none;
    font-size: 1.8rem;
  }
`

export const CtaLink = styled(Link)`
  color: ${props => props.theme.colors.blackBlue};
  font-size: ${props => props.theme.colors.paragraph};
  line-height: 2.2rem;
  text-decoration: none;
  font-weight: 700;
  display: inline-flex;
  align-item: center;
  transition: color 0.2s ease-out;
  &:hover {
    color: ${props => props.theme.colors.greyDarkblue};
    text-decoration: underline;
  }
  span {
    font-size: 1.1rem;
    padding-left: 1rem;
  }
  &.right {
    width: 100%;
    text-align: right;
  }
`

export const CtaHref = styled.a`
  color: ${props => props.theme.colors.blackBlue};
  font-size: ${props => props.theme.colors.paragraph};
  line-height: 2.2rem;
  text-decoration: none;
  font-weight: 700;
  display: inline-flex;
  align-item: center;
  transition: color 0.2s ease-out;
  &:hover {
    color: ${props => props.theme.colors.greyDarkblue};
    text-decoration: underline;
  }
  span {
    font-size: 1.1rem;
    padding-left: 1rem;
  }
  &.right {
    width: 100%;
    text-align: right;
  }
`

export const CtaHrefSpecial = styled.a`
  color: ${props => props.theme.colors.blackBlue};
  font-size: 2.2rem;
  line-height: 2.2rem;
  text-decoration: none;
  font-weight: 700;
  display: inline-flex;
  align-item: center;
  transition: color 0.2s ease-out;
  color: #fff;
  ${'' /* background: #3B6BA6;
  padding: 1rem 2rem;
  border-radius: 2rem; */}
  &:hover {
    ${'' /* color: ${props => props.theme.colors.greyDarkblue}; */}
    text-decoration: none;
    color: #FFB300;
  }
  span {
    font-size: 1.1rem;
    padding-left: 1rem;
  }
  &.right {
    width: 100%;
    text-align: right;
  }
`

export const CtaButton = styled.a`
  font-size: 1.5rem;
  height: 5rem;
  line-height: 4.9rem;
  display: inline-flex;
  border: .1rem solid ${props => props.theme.colors.greyDarkblue};
  padding: 0 4rem;
  border-radius: 3rem;
  color: ${props => props.theme.colors.greyDarkblue};
  outline: 0!important;
  cursor: pointer;
  font-weight: 700;
  text-decoration: none;
  &.small {
    line-height: 3.9rem;
    font-size: 1.3rem;
    height: 4rem;
  }
  @media (max-width: ${props => props.theme.breakpoints.l}) {
    line-height: 3.9rem;
    font-size: 1.2rem;
    height: 4rem;
  }
  &:hover {
    border-color: ${props => props.theme.colors.blackBlue};
    color: ${props => props.theme.colors.blackBlue};
  }
`
export const CtaButtonLink = styled(Link)`
  font-size: 1.5rem;
  height: 5rem;
  line-height: 4.9rem;
  display: inline-flex;
  background: ${props => props.theme.colors.greyDarkblue};
  padding: 0 4rem;
  border-radius: 3rem;
  color: white;
  outline: 0!important;
  cursor: pointer;
  font-weight: 700;
  text-decoration: none;
  transition: background-color 0.2s ease-out;
  &:hover {
    background: ${props => props.theme.colors.blackBlue};
    color: white;
    text-decoration: none;
  }
  @media (max-width: ${props => props.theme.breakpoints.l}) {
    height: 4rem;
    line-height: 3.9rem;
    font-size: 1.3rem;
  }
  &.default {
    border: .1rem solid ${props => props.theme.colors.greyDarkblue};
    color: ${props => props.theme.colors.greyDarkblue};
    ${'' /* background: white; */}
    background: transparent;
    text-align: center;
    width: 70%;
    display: block;
    margin: 0 auto;
    font-size: 2rem;
    @media (max-width: ${props => props.theme.breakpoints.s}) {
      height: 4rem;
      width: 100%;
      line-height: 3.9rem;
      font-size: 1.4rem;
    }
    &:hover {
      border-color: ${props => props.theme.colors.blackBlue};
      color: ${props => props.theme.colors.blackBlue};
    }
  }
`

// regular links
export const ChevronGLink = styled(Link)`
  font-family: 'roboto';
  font-weight: normal;
  color: ${props => props.theme.colors.greyDarkblue};
  font-size: 1.8rem;
  text-decoration: none;
  display: flex;
  align-items: center;
  justify-content: center;

  span, i {
    padding-left: 1rem;
    font-size: 1.3rem;
  }
  
`
export const ChevronLink = styled.a`
  font-family: 'roboto';
  font-weight: normal;
  color: ${props => props.theme.colors.greyDarkblue};
  font-size: 1.8rem;
  text-decoration: none;
  display: flex;
  align-items: center;
  span, i {
    padding-left: 1rem;
    font-size: 1.3rem;
  }
  &:hover {
    color: ${props => props.theme.colors.greyDarkblue};
    text-decoration: none;
  }
  @media (max-width: ${props => props.theme.breakpoints.s}) {
    margin-top: 2rem;
    justify-content: center;
  }
`

export const ChevronLinkGap = styled(ChevronLink)`
  padding: 0 0 0 1rem;
  text-decoration: underline;
  padding: 0 1rem 0 0;
`

export const ChevronGLinkFocus = styled(ChevronGLink)`
  padding: 0 0 2rem 1rem;
  span, i {
    padding-right: 1rem;
    font-size: 1.8rem;
  }
`
export const ChevronLinkFocusBlank = styled(ChevronLink)`
  padding: 0 0 2rem 1rem;
  span, i {
    padding-right: 1rem;
    font-size: 1.8rem;
  }
`
export const ChevronButtonFocus = styled.button`
  padding: 0 0 2rem 1rem;
  border: 0;
  background: transparent;
  span, i {
    padding-right: 1rem;
    font-size: 1.8rem;
  }
`
export const ChevronLinkFocus = styled(ChevronLink)`
  padding: 0 0 2rem 1rem;
  span, i {
    padding-right: 1rem;
    font-size: 1.8rem;
  }
`

export const ChevronLinkFitButton = styled(ChevronLink)`
  padding: 1rem 0 0 2rem;
`

export const CaseStudyLink = styled(ChevronLink)`
  font-size: 2rem;
  padding: 4rem 0 0 0;
  position: absolute;
  bottom: 4rem;
  span, i {
    font-size: 1.6rem;
  }
`

export const BoxBottomLink = styled(ChevronLink)`
  font-size: 2rem;
  padding: 4rem 0 0 0;
  position: absolute;
  bottom: 4rem;
  span, i {
    font-size: 1.6rem;
  }
`

export const BoxBottomButtonLink = styled(CtaButtonLink)`
  margin: 4rem 0 0 0;
`

export const BoxCtaContainer = styled.div`
  margin-top: -3rem;
`

export const BoxCtaContainerSpecial = styled.div`
  margin-top: -3rem;
  background: #3B6BA6;
  padding: 2.2rem 3rem 2rem;
  border-radius: .5rem;
  box-shadow: 1rem 1rem 3.4rem ${props => props.theme.colors.gradientBlueEnd};
`